




















































import {Component, Model, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {CostTranshipmentStore} from "@/modules/receiptsexpenses/updatecosttranshipment/store";
import {FormModel} from "ant-design-vue";
import {scanCostTranshipment} from "@/modules/receiptsexpenses/updatecosttranshipment/services";
import debounce from "lodash/debounce";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

class FormData {
    pickingListTranshipmentCode = "";
    transhipmentDocument = '';
    feeTranshipment?: number = undefined;
    feeAdd?: number = undefined;
    accept = false
}

@Component({
    name: "UpdateCostTranshipmentId",
    components: {AInputBarCode}
})
export default class extends mixins(CommonMixin) {
    @Model("id") readonly id!: number;

    form = {...new FormData()}

    get total() {
        return ((this.form.feeTranshipment ?? 0) + (this.form.feeAdd ?? 0))
    }

    private rules = {
        pickingListTranshipmentCode: [{required: true, message: "Nhập mã bảng kê", trigger: "change"}],
        transhipmentDocument: [{required: true, message: "Nhập chứng từ vận chuyển", trigger: "change"}],
        feeTranshipment: [{required: true, message: "Nhập phí vận chuyển", trigger: "change"}],
        feeAdd: [{required: false, message: "Nhập phí cộng thêm", trigger: "change"}],
        accept: [{required: false, message: "Mã chấp nhận", trigger: "change"}],
    };

    onChange(evt) {
        this.onChangeValue(this);
    }

    @Watch("id")
    async onChangeId() {
        if (this.id) {
            const data = await CostTranshipmentStore.singleCostTranshipment(this.id);
            this.form = {
                ...new FormData(), ...data,
                pickingListTranshipmentCode: data.pickingListTranshipment.code,
                accept: true
            };
            (this.$refs.formCostTranshipment as FormModel).clearValidate([])
        }
    }

    onChangeValue = debounce(async function (vm) {
        if (!vm.form.pickingListTranshipmentCode) {
            if (vm.id) vm.$emit("id", null);
            vm.form = {...new FormData()};
            return;
        }
        try {
            await scanCostTranshipment(vm.form.pickingListTranshipmentCode)
            vm.$set(vm.form, "accept", true);
            (vm.$refs.transhipmentDocument as any).focus();
        } catch (e) {
            vm.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
            vm.$set(vm.form, "accept", false);
        }
    }, 500)

    async onUpdate() {
        (this.$refs.formCostTranshipment as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                if (this.form.accept) {
                    this.id ?
                        await CostTranshipmentStore.updateCostTranshipment({...this.form, id: this.id})
                        :
                        await CostTranshipmentStore.createCostTranshipment(this.form)
                    this.form = {...new FormData()}
                    this.$emit("id", null)
                    this.$message.success("Cập nhập thành công")
                } else this.$message.error("Mã bảng kê không hợp lệ");
            } catch (e) {
                this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
            }
        })
    }
}
